import { Api } from '../api/Api.js'

export function apiGetCitiesDischarge(params) {
  return Api('get', '/get_cities_discharge', { params });
}
